var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUncheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FA2D1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.77242 6.77873C7.00673 6.54442 7.38663 6.54442 7.62094 6.77873L11.9967 11.1545L16.3724 6.77873C16.6067 6.54442 16.9866 6.54442 17.2209 6.77873C17.4553 7.01305 17.4553 7.39295 17.2209 7.62726L12.8452 12.003L17.2209 16.3787C17.4553 16.613 17.4553 16.9929 17.2209 17.2273C16.9866 17.4616 16.6067 17.4616 16.3724 17.2273L11.9967 12.8515L7.62094 17.2273C7.38663 17.4616 7.00673 17.4616 6.77242 17.2273C6.5381 16.9929 6.5381 16.613 6.77242 16.3787L11.1482 12.003L6.77242 7.62726C6.5381 7.39295 6.5381 7.01305 6.77242 6.77873Z",
    fill: "#FFEAE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckIcon);
export default __webpack_public_path__ + "static/media/uncheck_icon.eff695ce.svg";
export { ForwardRef as ReactComponent };